import styled from 'styled-components'

export const StyledForm = styled.form(({ theme }) => ({
  maxWidth: theme.space(132),
}))
